export default __webpack_public_path__ + "media/images/elephant-fren_sub.png.old-b4491bc8c2d2d8b93336cb571a8e2c0b.png";